module.exports = __webpack_public_path__ + "media/images/lb/644-f03fc8b9a06be30bb5284006c561bc83.svg";